export default __webpack_public_path__ + "static/media/menu-campaign.d86c71f3.svg";